import {Signal} from '@models/dashboard/signal';
import {Chart} from 'highcharts';

export class LineChartSettingsParameters {
  isLineChart: boolean = true;
  isInEditMode: boolean = false;
  machineId: string = '';
  highchartsChart: Chart | undefined;
  machineSignals: Signal[] = [];
  chartSettings: any;
  data: any[] = [];
  portalLanguage: string = 'en';
  stringData: any[] = [];
  chartId: string | undefined;
  isTemplateWidget: boolean = false;
}
